import { _t } from '@bark/bark-core';

export const shouldShowLeadDetailsNewDesign = () =>
	$('#js-show-new-lead-details-design').length;

export const applyLeadDetailsNewDesignResponseFlowChanges = (buyerName) => {
	const newTitle = _t('seller_response_flow:response-success.title', {
		buyer_name: truncateLongBuyerName(buyerName),
	});
	$(
		'#success_message_title .mobile-only-inline, #success_message_title .desktop-only-inline',
	).html(newTitle);

	$('.response-flow-container .response-flow-header-row').removeClass('px-lg-4 px-3');
	$('.response-flow-container .response-flow-header-row .response-flow-icon').removeClass(
		'align-self-start py-4',
	);
	$(
		'.response-flow-container .response-flow-header-row .response-flow-header',
	).removeClass('pt-4 pb-3');
	$(
		'.response-flow-container .response-flow-header-row .response-flow-header .response-flow-option p',
	).removeClass('mb-1 text-green');
	$('.response-flow-container .response-flow-row').removeClass('px-lg-4 px-3');

	$('.response-flow-step-content').removeClass('flex-lg-row');
	$('.response-flow-step-content .response-flow-option').removeClass('mb-lg-0 mb-4');
	$('.response-flow-step-content .response-flow-option p').removeClass('text-xs');
	$('.response-flow-step-content .response-flow-actions').removeClass('d-lg-block');
	$(
		'.response-flow-step-content .response-flow-actions .response-button-call-container-desktop-new',
	).removeClass('d-sm-block');
	$(
		'.response-flow-step-content .response-flow-actions .response-button-call-container-mobile-new',
	).removeClass('d-sm-none');
	$(
		'.response-flow-step-content .response-flow-actions .response-button-call-container-mobile-new .button-container',
	).removeClass('flex-md-grow-0');
	$(
		'.response-flow-step-content .response-flow-actions .response-button-call-container-mobile-new .button-container #seller-button-seller-call-mobile-new span',
	).removeClass('d-md-none');
	$(
		'.response-flow-step-content .response-flow-actions .response-button-call-container-mobile-new .copy-to-clip-btn-container',
	).removeClass('d-sm-none');
};

export const getContactButtonContainerSelector = () => {
	return Bark.seller.isMobile
		? '#project-details-contact-footer-mobile'
		: '#project-details-contact-card';
};

export const applyLeadDetailsNewDesignQnAChanges = () => {
	$('.project-details-question').addClass('pt-4');
	$('.project-details').removeClass('pt-5').addClass('mt-32p');
};

export const applyLeadDetailsNewDesignValueBadgesChanges = () => {
	setTimeout(() => {
		$('#__rctValueBadgesLeadDetails span.tw-text-base')
			.removeClass('tw-text-base')
			.addClass('tw-text-lg');
		$('#__rctValueBadgesLeadDetails div.tw-mt-5')
			.removeClass('tw-mt-5')
			.addClass('tw-mt-8');
	}, 500);
};

export const scrollToTopOnMobile = () => {
	if (Bark.seller.isMobile) $('.right-panel').animate({ scrollTop: 0 }, 500);
};

export const truncateLongBuyerName = (buyerName) => {
	return buyerName.length > 12 ? buyerName.substring(0, 12) + '...' : buyerName;
};
